import { Button, Checkbox, Form, Input, InputNumber, Select, message } from "antd";
import { useState } from "react";
import { postForm } from "~@/API/fake";
const EditFareTemplate = () => {
  const [form] = Form.useForm();
  const [loading,setLoading] = useState(false)
  const onFinish = async (values:any)=>{
    setLoading(true)
    setTimeout(async ()=>{
      const res = await postForm({...values, type: "批量修改运费模版"})
      setLoading(false)
      form.resetFields()
      message.success(res.originResponse.message)
    },2000)
  }
  return (
    <Form
      initialValues={{ productStatus: "1" }}
      form={form}
      layout="vertical"
      className="xl:max-w-xl"
      onFinish={onFinish}
    >
      <h2 className="font-medium mb-4 ">商品范围</h2>
      <Form.Item label="商品状态" name="productStatus">
        <Checkbox.Group
          options={[
            { label: "出售中", value: "1" },
            { label: "仓库中", value: "2" },
          ]}
        />
      </Form.Item>
      <Form.Item label="价格范围">
        <div className="flex items-center gap-x-2">
          <Form.Item name="priceMin" noStyle>
            <InputNumber placeholder="最低价" className="min-w-[220px]" />
          </Form.Item>
          <span> - </span>
          <Form.Item name="priceMax" noStyle>
            <InputNumber placeholder="最高价" className="min-w-[220px]" />
          </Form.Item>
        </div>
      </Form.Item>

      <Form.Item label="库存范围">
        <div className="flex items-center gap-x-2">
          <Form.Item name="stockMin" noStyle>
            <InputNumber placeholder="最低库存" className="min-w-[220px]" />
          </Form.Item>
          <span> - </span>
          <Form.Item name="stockMax" noStyle>
            <InputNumber placeholder="最高库存" className="min-w-[220px]" />
          </Form.Item>
        </div>
      </Form.Item>
      <Form.Item label="标题筛序">
        <div className="space-y-2">
          <div className="flex items-center   gap-x-2">
            <span className="flex-shrink-0">选择标题包含</span>
            <Form.Item noStyle>
              <Input placeholder="多个关键词用英文“,”隔开" />
            </Form.Item>
            <span className="flex-shrink-0">的商品</span>
          </div>
          <div className="flex items-center  gap-x-2">
            <span className="flex-shrink-0">排除标题包含</span>
            <Form.Item noStyle>
              <Input placeholder="多个关键词用英文“,”隔开" />
            </Form.Item>
            <span className="flex-shrink-0">的商品</span>
          </div>
        </div>
      </Form.Item>
      <Form.Item label="编码筛选">
        <div className="flex items-center  gap-x-2">
          <span className="flex-shrink-0">选择编码包含</span>
          <Form.Item noStyle>
            <Input placeholder="多个关键词用英文“,”隔开" />
          </Form.Item>
          <span className="flex-shrink-0">的商品</span>
        </div>
      </Form.Item>
      <h2 className="font-medium mb-4 ">修改内容</h2>

      <Form.Item>
        <div className="flex items-center gap-x-2">
          <span className="flex-shrink-0">运费模板</span>
          <Form.Item noStyle>
            <Select placeholder="请选择模板" />
          </Form.Item>
        </div>
      </Form.Item>
      <div className="space-x-4">
        <Button type="primary" htmlType="submit" loading={loading}>提交任务</Button>
      </div>
    </Form>
  );
};

export default EditFareTemplate;
